import axios from '../../common/utils/interceptor';
import { apiUrls, WorkflowStatus } from '../../constants';
import { SessionStore } from '../../constants/sessionStore';

export const markWorkflowEnd = async (): Promise<void> => {
  const workflowEndConfig = sessionStorage.getItem(SessionStore.endPageConfig);
  const workflowSession = sessionStorage.getItem(SessionStore.workflowSession);

  if (!workflowEndConfig && workflowSession && JSON.parse(workflowSession).status !== WorkflowStatus.COMPLETED) {
    try {
      const { data } = await axios.post(apiUrls.POST_WORKFLOW_END);
      if (data) sessionStorage.setItem(SessionStore.endPageConfig, JSON.stringify(data));
    } catch (e) {
      console.error('Workflow end error: ', e);
    }
  }
};
